import { Menu, MenuItem } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React, { useState, useEffect } from 'react';

import { getDateFormat } from '../../_helpers/useful-functions';
import FilterDatepicker from '../../components/filter-datepicker';
import MultiSelect from '../../components/filter-multiSelect-allSelect-new';
import { IFilterModal } from '../../models/moments-report/filter-modal';
import { useAppDispatch, useAppSelector } from '../../store';
import {
    getMomentReportMenuList,
    getMomentReportsDashboardFeed,
    getMomentReportsGropuTitleGrid,
    setCheckboxValue,
    setFilterOpen,
    setIsFilterTouch,
    setIsFilterValidate,
    setReportFilter,
    setYellowWarning,
} from '../../store/features/moments-reports/momentReportsSlice';

const FilterModal = ({ setIsOpenFilterModal, isOpenFilterModal }: IFilterModal) => {
    const [isTouched, setIsTouched] = useState<boolean>(false);
    const [isValid, setIsValid] = useState<boolean>(true);
    const [submitUpdate, setSubmitUpdate] = useState<number>(1);
    const [companyValue, setCompanyValue] = useState([]);
    const { words } = useAppSelector(state => state.localization);
    const dispatch = useAppDispatch();
    const { reportFilter,  page, checkboxValue, companyAllListWithLabelValue, gridTableGroupTitle } = useAppSelector(
        state => state.momentReports,
    );
    const { pageIndex } = useAppSelector(state => state.momentReports.gridTableGroupTitle);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const selectAllLabel = 'Tüm Şirketler';

    useEffect(() => {
        if (isValid) dispatch(setIsFilterValidate(true));
        if (!isValid) dispatch(setIsFilterValidate(false));
    }, [isValid]);

    useEffect(() => {
        if (checkboxValue) {
            setAnchorEl(anchorEl);
        }
    }, [checkboxValue]);

    useEffect(() => {
        //!update new companies name and id
        dispatch(
            setReportFilter({
                ...reportFilter,
                companyList: companyValue,
            }),
        );
    }, [companyValue]);

    useEffect(() => {
        const companyIdList_ = [];
        const companyNameList_ = [];
        if (reportFilter?.companyList?.length > 0) {
            //!set companyList id
            for (let i = 0; i < reportFilter?.companyList?.length; i++) {
                const element = reportFilter?.companyList[i];
                companyIdList_.push(element?.value);
            }
            //!set companyList name
            for (let i = 0; i < reportFilter?.companyList?.length; i++) {
                const element = reportFilter?.companyList[i];
                companyNameList_.push(element?.label);
            }
        }
        //!update new company Ids...
        dispatch(
            setReportFilter({
                ...reportFilter,
                companyIdList: companyIdList_,
                companyNameList: companyNameList_,
            }),
        );
    }, [reportFilter?.companyList]);

    const handleClose = () => {
        setIsOpenFilterModal(false);
        dispatch(setFilterOpen(false));

    };

    const handleCloseMenu = () => {
        if (checkboxValue?.length !== 0) {
            setAnchorEl(null);
        }
    };

    const handleSwipe = () => {
        if (companyAllListWithLabelValue?.items?.length !== 1) {
            dispatch(
                setReportFilter({
                    companyList: [],
                    startDate: null,
                    endDate: null,
                    companyIdList: [],
                    companyNameList: [],
                }),
            );
            dispatch(setCheckboxValue(''));
        } else if (companyAllListWithLabelValue?.items?.length === 1) {
            dispatch(
                setReportFilter({
                    ...reportFilter,
                    startDate: null,
                    endDate: null,
                }),
            );
        }
    };

    const handleFilterClick = async () => {
        dispatch(setFilterOpen(false));
        let isValidation = true;
        setIsTouched(true);
        //!validation
        if (reportFilter?.companyIdList?.length === 0) return (isValidation = false);
        if (reportFilter?.startDate && !reportFilter?.endDate) return (isValidation = false);
        if (!reportFilter?.startDate && reportFilter?.endDate) return (isValidation = false);

        //!check valid or invalid Date..
        if (
            new Date(reportFilter?.startDate).toDateString() === 'Invalid Date' ||
            getDateFormat({ date_: reportFilter?.startDate }) === 'Invalid Date' ||
            new Date(reportFilter?.endDate).toDateString() === 'Invalid Date' ||
            getDateFormat({ date_: reportFilter?.endDate }) === 'Invalid Date'
        ) {
            return (isValidation = false);
        }

        //! check startDate and endDate situations..
        if (
            new Date(reportFilter?.startDate) > new Date(reportFilter?.endDate) ||
            new Date(reportFilter?.endDate) < new Date(reportFilter?.startDate)
        ) {
            return (isValidation = false);
        }

        if (!isValidation) {
            setIsValid(false);
            setSubmitUpdate(submitUpdate + 1);
            return true;
        } else {
            setIsValid(true);
        }

        if (isValid) {
            dispatch(setIsFilterTouch(true));

            //!if it is valid so update yellowWarnings data..
            dispatch(
                setYellowWarning({
                    startDate: reportFilter?.startDate,
                    endDate: reportFilter?.endDate,
                    companyNameList: reportFilter?.companyNameList,
                }),
            );

            dispatch(
                getMomentReportMenuList({
                    startDate: getDateFormat({ date_: reportFilter?.startDate }),
                    endDate: getDateFormat({ date_: reportFilter?.endDate }),
                    companyList: reportFilter?.companyIdList,
                }),
            );

            if (page.subPage === 'notifications-grid') {
                dispatch(
                    getMomentReportsGropuTitleGrid({
                        ...gridTableGroupTitle,
                        startDate: getDateFormat({ date_: reportFilter?.startDate }),
                        endDate: getDateFormat({ date_: reportFilter?.endDate }),
                        companyIdList: reportFilter?.companyIdList,
                        pageSize: 50,
                        pageIndex,
                    }),
                );
            } else if (page.subPage === 'dashboard-feed') {
                dispatch(
                    getMomentReportsDashboardFeed({
                        startDate: getDateFormat({ date_: reportFilter?.startDate }),
                        endDate: getDateFormat({ date_: reportFilter?.endDate }),
                        companyList: reportFilter.companyIdList,
                    }),
                );
            } else if (page.subPage === 'groupTitle-grid') {
                dispatch(
                    getMomentReportsGropuTitleGrid({
                        ...gridTableGroupTitle,
                        startDate: getDateFormat({ date_: reportFilter?.startDate }),
                        endDate: getDateFormat({ date_: reportFilter?.endDate }),
                        companyIdList: reportFilter?.companyIdList,
                        pageSize: 50,
                        pageIndex,
                    }),
                );
            }
            handleClose();
            dispatch(setIsFilterTouch(false));
        }

        return false;
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-15"
            open={isOpenFilterModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
                className: 'f-backdrop-bg',
            }}
            hideBackdrop>
            <Fade in={isOpenFilterModal}>
                <>
                    <div className="modal-content-15">
                        <div className="c-filter-icon-group">
                            <div className="c-item-icon-group">
                                <svg
                                    className="c-item-filter-icon"
                                    data-name="Group 11815"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="45"
                                    height="45"
                                    viewBox="0 0 45 45">
                                    <g data-name="Group 43">
                                        <path
                                            data-name="Path 28"
                                            d="M10 0h25a10 10 0 0 1 10 10v25a10 10 0 0 1-10 10H10A10 10 0 0 1 0 35V10A10 10 0 0 1 10 0z"
                                            fill="#40a2ff"
                                        />
                                    </g>
                                    <path
                                        data-name="Path 32"
                                        d="M17.811-16.625H1.189a1.188 1.188 0 0 0-.84 2.025l6.776 6.779v6.93A1.184 1.184 0 0 0 7.531 0l2.374 2.081a1.188 1.188 0 0 0 1.969-.894v-9.008l6.777-6.779a1.188 1.188 0 0 0-.84-2.025zm-7.124 8.313v9.5L8.312-.891v-7.421l-7.125-7.125h16.625z"
                                        transform="translate(14 31)"
                                        fill="#fff"
                                    />
                                </svg>
                                <span className="c-item-title">Filtre</span>
                            </div>

                            <svg
                                onClick={handleClose}
                                className="c-item-close-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="12.5"
                                height="12.5"
                                viewBox="0 0 12.5 12.5">
                                <path
                                    data-name="Path 5778"
                                    d="m7.576-7.5 4.006-4.006.826-.826a.313.313 0 0 0 0-.442l-.884-.884a.313.313 0 0 0-.442 0L6.25-8.826l-4.832-4.833a.313.313 0 0 0-.442 0l-.884.884a.313.313 0 0 0 0 .442L4.924-7.5.091-2.668a.313.313 0 0 0 0 .442l.884.884a.313.313 0 0 0 .442 0L6.25-6.174l4.006 4.006.826.826a.313.313 0 0 0 .442 0l.884-.884a.313.313 0 0 0 0-.442z"
                                    transform="translate(0 13.75)"
                                    fill="#707070"
                                />
                            </svg>
                        </div>

                        <div className="c-item-01">
                            <button className={reportFilter?.companyIdList?.length !== 0 ? 'button-13' : 'button-13 error'} onClick={handleClick}>
                                <span>
                                    {companyAllListWithLabelValue?.items?.length === 1
                                        ? companyAllListWithLabelValue?.items[0]?.label
                                        : reportFilter.companyNameList.length === 0
                                        ? 'Şirket'
                                        : checkboxValue
                                        ? checkboxValue
                                        : selectAllLabel}
                                </span>
                                <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L6.5 7L12 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            {Boolean(anchorEl) && (
                                <div
                                    className={companyAllListWithLabelValue?.items?.length !== 1 ? 'c-item-01-A' : 'c-item-01-A f-company-single'}
                                    // id={companyAllListWithLabelValue?.items?.length !== 1 ? 'f-company-page' : 'f-company-page-single'}
                                >
                                    <Menu
                                        id="simple-menu-company"
                                        className="c-item-company filter-company-menu"
                                        transitionDuration={0}
                                        elevation={0}
                                        getContentAnchorEl={null}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        hideBackdrop
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleCloseMenu}>
                                        <MenuItem className="f-company-item-list">
                                            <MultiSelect
                                                open={Boolean(anchorEl)}
                                                isTouched={isTouched}
                                                limitTags={2}
                                                placeholder="Şirket"
                                                selectAllLabel={selectAllLabel}
                                                noOptionsText="Aradığınız şirketi bulamadık"
                                                onChange={setCompanyValue}
                                            />
                                        </MenuItem>
                                        <MenuItem className="f-swipe-accept-item">
                                            <button className="button-16 f-accept" onClick={handleCloseMenu}>
                                                <span className="text-01 f-fix-extra"> ,Uygula</span>
                                            </button>
                                        </MenuItem>
                                    </Menu>
                                </div>
                            )}

                            <FilterDatepicker type="start" isTouched={isTouched} />
                            <FilterDatepicker type="end" isTouched={isTouched} />

                            <div className="c-item-button-group">
                                <button onClick={handleSwipe} className="button-15">
                                    <span className="text-01">Temizle</span>
                                </button>

                                <button onClick={handleFilterClick} className="button-16">
                                    <span className="text-01">{words && words['WEB.filters']}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            </Fade>
        </Modal>
    );
};

export default FilterModal;
